export default "__VITE_ASSET__CsJ8nwnT__"